import React from "react";

const NotificationSkeleton: React.FC = () => {
  return (
    <div className=" bg-background p-3 rounded-lg mb-4 animate-pulse">
      <div className="max-h-90 overflow-auto">
        {/* Simulating loading state with 3 placeholder groups */}
        {[...Array(8)].map((_, i) => (
          <div key={i}>
            <div className="h-4 w-32 bg-gray-300  rounded-md mb-2 animate-pulse "></div>{" "}
            {/* Date skeleton */}
            <div className="rounded-xl">
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  <div className="w-[42px] h-[42px] bg-gray-300 rounded-full mr-2 animate-pulse"></div>{" "}
                  {/* Profile pic skeleton */}
                  <div className="h-4 w-[285px] bg-gray-300 rounded-md animate-pulse"></div>{" "}
                  {/* Title skeleton */}
                </div>
                <div className="w-auto h-[72px] bg-gray-300 animate-pulse"></div>{" "}
                {/* Image skeleton */}
              </div>
            </div>
            {/* *=============Old Code===========* */}
            {/* {[...Array(3)].map((_, j) => (
              <div className="rounded-xl">
                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-[42px] h-[42px] bg-gray-300 rounded-full mr-2 animate-pulse"></div>{" "}
                    <div className="h-4 w-[285px] bg-gray-300 rounded-md animate-pulse"></div>{" "}
                  </div>
                  <div className="w-auto h-[72px] bg-gray-300 animate-pulse"></div>{" "}
                </div>
              </div>
            ))} */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationSkeleton;
